import { CommentsComponent } from './comments/comments.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Mobile
import { HotelDetailMobileComponent } from './hotel-detail-mobile/hotel-detail-mobile.component';
import { BestRoomPriceboxMobileComponent } from './best-room-pricebox-mobile/best-room-pricebox-mobile.component';
import { PriceBoxMobileComponent } from './price-box-mobile/price-box-mobile.component';
import { ViewMapMobileComponent } from './view-map-mobile/view-map-mobile.component';
import { DetailClusterMobileComponent } from './detail-cluster-mobile/detail-cluster-mobile.component';
import { RoomOptionsMobileComponent } from './room-options/room-options-mobile/room-options-mobile.component';
import { DetailFiltersMobileComponent } from './detail-filters-mobile/detail-filters-mobile.component';
import { PhotosMobileComponent } from './header-detail/photos-mobile/photos-mobile.component';

// Desktop
import { AccommodationFeeComponent } from './accommodation-fee/accommodation-fee.component';
import { BestRoomPriceboxComponent } from './best-room-pricebox/best-room-pricebox.component';
import { CancelPoliciesComponent } from './cancel-policies/cancel-policies.component';
import { CancelPoliciesInformationComponent } from './cancel-policies-information/cancel-policies-information.component';
import { ChargesComponent } from './charges/charges.component';
import { CheckTimesComponent } from './check-times/check-times.component';
import { DescriptionComponent } from './description/description.component';
import { DetailClusterComponent } from './detail-cluster/detail-cluster.component';
import { HeaderDetailComponent } from './header-detail/header-detail.component';
import { HotelDetailComponent } from './hotel-detail/hotel-detail.component';
import { HotelIntroComponent } from './hotel-intro/hotel-intro.component';
import { ImageMessageComponent } from './image-message/image-message.component';
import { PriceBoxComponent } from './price-box/price-box.component';
import { RoomComponent } from './room/room.component';
import { RoomOptionsComponent } from './room-options/room-options/room-options.component';
import { UniversalBenefitsDetailComponent } from './universal-benefits-detail/universal-benefits-detail.component';
import { PaymentMethodSelectorComponent } from './payment-method-selector/payment-method-selector.component';
import { TripadavisorReviewsComponent } from './tripadvisor-reviews/tripadvisor-reviews.component';
import { ServicesComponent } from './services/services.component';
import { SeoDetailComponent } from './seo-detail/seo-detail.component';
import { RefundableRateComponent } from './refundable-rate/refundable-rate.component';
import { DetailMenuComponent } from './detail-menu/detail-menu.component';

// Disney
import { ActivitiesInformationDisneyComponent } from '../disney/activities-information/activities-information.component';
import { BenefitsDisneyComponent } from '../disney/benefits/benefits.component';
import { DisneyClusterDisneyComponent } from '../disney/disney-cluster/disney-cluster.component';
import { ParkingDisneyComponent } from '../disney/parking/parking.component';
import { TicketPurchasePolicyComponent } from '../disney/ticket-purchase-policy/ticket-purchase-policy.component';

// Todo: add this module: import { AmExpertsReviewCarouselModule } from '@am/experts-review-carousel';
import { AmExpertsShareComponent } from '@am/experts-share';
import { AmRewardsPricingComponent } from '@am/rewards-pricing';
import { AmTripsAddProductModule } from '@am/trips-add-product';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { AmExpertsCompensationComponent } from '@am/experts-compensation';
import {
  MbAdvice,
  MbAlert,
  MbBadge,
  MbBarRating,
  MbButton,
  MbCard,
  MbCarousel,
  MbComments,
  MbCommunication,
  MbDialogHeader,
  MbDialogBody,
  MbExpandablePanel,
  MbExpandableText,
  MbFormField,
  MbIcon,
  MbIconText,
  MbPopoverTrigger,
  MbRecommendedCard,
  MbReviewsRating,
  MbStarsRating,
  MbSwitch,
  MbTabs,
  MbTooltipTrigger,
} from '@am/moebius';
import { PaymentAdviseComponent } from './detail-cluster/payment-advise/payment-advise.component';
import { TotalPriceComponent } from './detail-cluster/total-price/total-price.component';
import { ComboTicketComponent } from '../disney/combo-ticket/combo-ticket.component';
import { MealPlanComponent } from './detail-cluster/meal-plan/meal-plan.component';
import { PaymentAdviseInfoComponent } from './detail-cluster/payment-advise-info/payment-advise-info.component';
import { FiltersComponent } from './hotel-detail-mobile/filters/filters.component';
import { HeaderComponent } from './hotel-detail-mobile/header/header.component';
import { RoomSummaryComponent } from './hotel-detail-mobile/room-summary/room-summary.component';
import { RoomHeaderComponent } from './hotel-detail-mobile/room-summary/room-header/room-header.component';
import { PaymentMethodsComponent } from './hotel-detail-mobile/room-summary/payment-methods/payment-methods.component';
import { MealPlansComponent } from './hotel-detail-mobile/room-summary/meal-plans/meal-plans.component';
import { RateDetailComponent } from './hotel-detail-mobile/rate-detail/rate-detail.component';
import { RoomInformationComponent } from './hotel-detail-mobile/room-summary/room-information/room-information.component';
import { DisneySupplementsComponent } from './hotel-detail-mobile/room-summary/disney-supplements/disney-supplements.component';
import { DisneyCombosComponent } from './disney-combos/disney-combos.component';
import { RoomFiltersComponent } from './room-filters/room-filters.component';
import { FiltersContainerComponent } from './hotel-detail/filters-container/filters-container.component';

const MOEBIUS_IMPORTS = [
  MbAdvice,
  MbFormField,
  MbButton,
  MbAlert,
  MbIcon,
  MbIconText,
  MbTooltipTrigger,
  MbExpandableText,
  MbExpandablePanel,
  MbBadge,
  MbStarsRating,
  MbReviewsRating,
  MbTabs,
  MbDialogHeader,
  MbDialogBody,
  MbSwitch,
  MbPopoverTrigger,
  MbCard,
  MbCommunication,
  MbRecommendedCard,
  MbBarRating,
  MbComments,
  MbCarousel,
  MbExpandablePanel,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AmExpertsShareComponent,
    AmExpertsCompensationComponent,
    SharedModule,
    AmRewardsPricingComponent,
    AmTripsAddProductModule,
    ...MOEBIUS_IMPORTS,
    AccommodationFeeComponent,
    BestRoomPriceboxComponent,
    CancelPoliciesComponent,
    CancelPoliciesInformationComponent,
    ChargesComponent,
    CheckTimesComponent,
    DescriptionComponent,
    DetailClusterComponent,
    HeaderDetailComponent,
    HotelDetailComponent,
    HotelIntroComponent,
    ImageMessageComponent,
    PriceBoxComponent,
    RoomComponent,
    RoomOptionsComponent,
    TripadavisorReviewsComponent,
    ServicesComponent,
    SeoDetailComponent,
    UniversalBenefitsDetailComponent,
    PaymentMethodSelectorComponent,
    ActivitiesInformationDisneyComponent,
    BenefitsDisneyComponent,
    DisneyClusterDisneyComponent,
    ParkingDisneyComponent,
    HotelDetailMobileComponent,
    BestRoomPriceboxMobileComponent,
    PriceBoxMobileComponent,
    ViewMapMobileComponent,
    DetailClusterMobileComponent,
    RoomOptionsMobileComponent,
    DetailFiltersMobileComponent,
    RefundableRateComponent,
    TicketPurchasePolicyComponent,
    DetailMenuComponent,
    PhotosMobileComponent,
    CommentsComponent,
    PaymentAdviseComponent,
    TotalPriceComponent,
    ComboTicketComponent,
    MealPlanComponent,
    PaymentAdviseInfoComponent,
    FiltersComponent,
    HeaderComponent,
    RoomSummaryComponent,
    RoomHeaderComponent,
    RoomFiltersComponent,
    PaymentMethodsComponent,
    MealPlansComponent,
    RateDetailComponent,
    RoomInformationComponent,
    DisneySupplementsComponent,
    DisneyCombosComponent,
    FiltersContainerComponent,
  ],
  exports: [
    AccommodationFeeComponent,
    BestRoomPriceboxComponent,
    CancelPoliciesComponent,
    CancelPoliciesInformationComponent,
    ChargesComponent,
    CheckTimesComponent,
    DescriptionComponent,
    DetailClusterComponent,
    HeaderDetailComponent,
    HotelDetailComponent,
    HotelIntroComponent,
    ImageMessageComponent,
    PriceBoxComponent,
    RoomComponent,
    RoomOptionsComponent,
    TripadavisorReviewsComponent,
    ServicesComponent,
    SeoDetailComponent,
    UniversalBenefitsDetailComponent,
    PaymentMethodSelectorComponent,
    ActivitiesInformationDisneyComponent,
    BenefitsDisneyComponent,
    DisneyClusterDisneyComponent,
    ParkingDisneyComponent,
    HotelDetailMobileComponent,
    BestRoomPriceboxMobileComponent,
    PriceBoxMobileComponent,
    ViewMapMobileComponent,
    DetailClusterMobileComponent,
    RoomOptionsMobileComponent,
    DetailFiltersMobileComponent,
    RefundableRateComponent,
    TicketPurchasePolicyComponent,
    DetailMenuComponent,
    PhotosMobileComponent,
    CommentsComponent,
    PaymentAdviseComponent,
    TotalPriceComponent,
    PaymentAdviseInfoComponent,
    RoomInformationComponent,
    RoomFiltersComponent,
    FiltersContainerComponent,
  ],
})
export class DetailComponentsModule {}
